import React from 'react';
import styles from './UIGamePlayerInfo.module.scss';
import clsx from 'clsx';
import { UIGamePlayerInfoHeader } from './UIGamePlayerInfoHeader/UIGamePlayerInfoHeader.tsx';
import { UIGamePlayerInfoFooter } from './UIGamePlayerInfoFooter/UIGamePlayerInfoFooter.tsx';
import { UIGamePlayerInfoBody } from './UIGamePlayerInfoBody/UIGamePlayerInfoBody.tsx';
import { UIGamePlayerInfoExtraFooter } from './UIGamePlayerInfoExtraFooter/UIGamePlayerInfoExtraFooter.tsx';
const DEFAULT_HEADER_WRAPPER = (header)=>header;
export const UIGamePlayerInfo = ({ header, headerWrapper = DEFAULT_HEADER_WRAPPER, footer, extraFooter, playerColor, children })=>{
    const headerElement = /*#__PURE__*/ React.createElement(UIGamePlayerInfoHeader, {
        playerColor: playerColor,
        ...header
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.containerInner, {
            [styles.hasFooter]: footer !== undefined
        })
    }, headerWrapper(headerElement), /*#__PURE__*/ React.createElement(UIGamePlayerInfoBody, {
        playerColor: playerColor
    }, children), footer && /*#__PURE__*/ React.createElement(UIGamePlayerInfoFooter, footer)), /*#__PURE__*/ React.createElement("div", {
        className: styles.extraFooterContainer
    }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoExtraFooter, extraFooter)));
};
